import React, { useCallback, useEffect, useState } from 'react'
import StringUtil from 'utils/string-util'
import ContractApiV2 from 'api/v2/admins/contracts-api-v2'
import { InputField } from 'components'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag  : PropTypes.any,
  fieldName  : PropTypes.string,
  sellerType : PropTypes.string,
  disabled   : PropTypes.bool
}

const defaultValues = {
  formikBag  : null,
  fieldName  : '',
  sellerType : '',
  disabled   : false
}

/**
 * Contract options for dropdown input field. hooked up to Formik (only to be used within a Formik component)
 * @param {any} formikBag an object containing a subset of the injected props and methods and any props that were passed to the wrapped component.
 * @param {string} fieldName name for fieldName input-field
 */
const SellerContractField = ({
  formikBag,
  fieldName,
  sellerType,
  disabled
}) => {
  const [ contracts, setContracts ]   = useState([])
  const [ totalCount, setTotalCount ] = useState(1)

  const getContracts = useCallback((sellerType) => {
    if ((sellerType === 'normal') || (sellerType === 'featured') || (sellerType === 'designer') || (sellerType === 'scraper')){
      sellerType = 'normalOrfeatured'
    }

    const additionalFilters = {
      per_page    : totalCount,
      seller_type : sellerType
    }

    ContractApiV2.get({
      additionalFilters: additionalFilters
    })
      .then((response) => {
        setContracts(response.data.contracts)
        setTotalCount(response.data.meta.total_count)
      })
      .catch((error) => {
        alert(error)
      })
  }, [ totalCount ])

  // get Contracts data
  useEffect(() => {
    getContracts(sellerType)
  }, [ getContracts, sellerType, totalCount ])

  // components to show
  const SelectFieldOptions = () => (
    <>
      <option value={ '' } label={ 'Choose Contract' }/>
      {
        contracts.map((option) => (
          <option
            key={ `select-option-contract-${option.id}` }
            value={ option.id }
            label={ StringUtil.titleCase(option.type_of) }
          />
        ))
      }
    </>
  )

  return (
    <InputField
      type='select'
      name={ fieldName }
      label='Contract'
      required={ true }
      onChange={ (e) => formikBag.handleChange(e) }
      disabled={ disabled }
    >
      <SelectFieldOptions />
    </InputField>
  )
}

SellerContractField.propTypes    = propTypes
SellerContractField.defaultProps = defaultValues

export default SellerContractField